import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { stringToColor } from '../utils'

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [],
  templateUrl: './avatar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './avatar.component.scss',
})
export class AvatarComponent {
  @Input()
  input!: string

  @Input()
  size: 'normal' | 'small' = 'normal'

  getInitials(input: string) {
    const parts = input
      .replace(/\([^)]*\)?/g, ' ')
      .split(' ')
      .filter((part) => part.length > 0)
    if (parts.length === 1 && parts[0].length > 0) {
      return parts[0][0].toUpperCase()
    } else if (parts.length >= 2 && parts[0].length > 0 && parts[1].length > 0) {
      return parts[0][0].toUpperCase() + parts[1][0].toUpperCase()
    } else {
      return ''
    }
  }

  generateBackgroundColor(input: string) {
    return stringToColor(input)
  }
}
